function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import classnames from 'classnames';
import { IconItem } from "../../Item/IconItem/IconItem";
import styles from "./IconItemList.module.scss";
import { VerticalSpacer } from "../../VerticalSpacer/VerticalSpacer";
import { jsx as _jsx } from "react/jsx-runtime";
export var iconItemListMarginVariants = ['noMargin', 'normalMargin'];
export var IconItemList = function IconItemList(_ref) {
  var _ref$ids = _ref.ids,
    ids = _ref$ids === void 0 ? [] : _ref$ids,
    iconItems = _ref.iconItems,
    _ref$horizontal = _ref.horizontal,
    horizontal = _ref$horizontal === void 0 ? false : _ref$horizontal,
    fileIconClass = _ref.fileIconClass,
    align = _ref.align,
    iconSize = _ref.iconSize,
    marginVariant = _ref.marginVariant,
    verticalSpacer = _ref.verticalSpacer,
    _ref$processJSON = _ref.processJSON,
    processJSON = _ref$processJSON === void 0 ? false : _ref$processJSON;
  var handlePadding = function handlePadding() {
    if (marginVariant === 'noMargin' || (verticalSpacer === null || verticalSpacer === void 0 ? void 0 : verticalSpacer.padding) === 'none') {
      return 'none';
    } else {
      return 'default';
    }
  };
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.wrapper, {
      [styles.horizontal]: horizontal
    }),
    children: iconItems === null || iconItems === void 0 ? void 0 : iconItems.map(function (item, key) {
      return /*#__PURE__*/_jsx("div", {
        className: styles.item,
        children: /*#__PURE__*/_jsx(VerticalSpacer, _objectSpread(_objectSpread({}, verticalSpacer), {}, {
          className: styles.margin,
          padding: handlePadding(),
          children: /*#__PURE__*/_jsx(IconItem, _objectSpread(_objectSpread({}, item), {}, {
            id: ids[key],
            horizontal: horizontal,
            fileIconClass: fileIconClass,
            align: align,
            iconSize: iconSize,
            processJSON: processJSON
          }))
        }))
      }, key);
    })
  });
};